import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  isDevMode,
  OnInit,
  TemplateRef,
  inject,
} from '@angular/core';
import { CarouselService } from '@boels/helpers';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
  faCircle,
} from '@fortawesome/free-solid-svg-icons';
import { Observable, tap } from 'rxjs';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

@Component({
  selector: 'boels-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FontAwesomeModule],
  providers: [CarouselService],
})
export class CarouselComponent implements OnInit {
  protected el = inject(ElementRef);
  protected carouselService = inject(CarouselService);

  @Input() title: string;
  @Input() template: TemplateRef<any>;
  @Input() itemWidth = '300px';
  @Input() hideIndicators = false;
  @Input() indicatorIcon: IconDefinition;
  @Input() openOnGalleryIndex = 0;

  @Input()
  set items(inputItems: Observable<any>[]) {
    this._items = inputItems;
    //Reset slider when changing products
    this.activeSlide = 0;
  }

  get items(): Observable<any>[] {
    return this._items;
  }

  private _items: Observable<any>[];

  activeSlide: number;
  size$: Observable<number>;
  indicatorSelectedIcon = faCircle;
  @Input() previousIcon = faChevronLeft;
  @Input() nextIcon = faChevronRight;

  ngOnInit() {
    if (!this.template && isDevMode()) {
      return;
    }
    this.size$ = this.carouselService
      .getItemsPerSlide(this.el.nativeElement, this.itemWidth)
      .pipe(tap(() => (this.activeSlide = this.openOnGalleryIndex || 0)));
  }

  getSlideNumber(size: number, currentIndex: number): number {
    const normalizedCurrentIndex = currentIndex + 1;
    return Math.ceil(normalizedCurrentIndex / size);
  }
}
